import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const RootBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const YouTubeWrapper = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  overflow: "hidden",
  width: "100%",
}));

export const SectionTitleTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: "bold",
  fontSize: "18px",
  color: theme.palette.text.primary,
  marginTop: theme.spacing(4),
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));
